import {
  getOrganizationBySlug
} from "./chunk-QS4UHVNQ.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/organization/bySlug.ts
import { useQuery } from "@tanstack/react-query";
var useGetOrganizationBySlug = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["organizationsBySlug", props],
    queryFn: () => getOrganizationBySlug(props)
  }, options));
};

export {
  useGetOrganizationBySlug
};
//# sourceMappingURL=chunk-F6KX6LGZ.mjs.map